<template>
    <rkm-form
        ref="RkmForm"
    >

        <rkm-alert show color="warning">
            <strong>Atenção:</strong> O tamanho da imagem deve ser exatamente de 250px de largura
                e 150px de altura.
        </rkm-alert>

        <rkm-alert show info>
            <strong>Profissional:</strong>
            {{ this.item.nome }}
        </rkm-alert>

        <rkm-area title="Cadastrar assinatura" v-if="!assinatura">
            <rkm-row>
                <rkm-col>
                    <rkm-form-file
                        v-model="model.assinatura"
                        type="file"
                        placeholder="SELECIONE UMA ASSINATURA"
                        accept=".png, .jpg"
                        browse-text="Selecionar"
                        drop-placeholder="Arraste e solte aqui..."
                        ref="file-input"
                    >
                        Pesquisar
                    </rkm-form-file>
                </rkm-col>
            </rkm-row>
        </rkm-area>

        <rkm-area title="Assinatura cadastrada" v-else>

            <rkm-table
                :items="items"
                :fields="fields.tables.assinatura"
                hide-filters
                hide-pagination
                tag="div"
            >
                <template v-slot:cell(actions)="{ item }">

                    <rkm-button
                        @click="handleDownload(item)"
                        color="primary"
                        small
                        title="Baixar"
                    >
                        <rkm-icon icon="download" />
                    </rkm-button>

                    <rkm-button
                        @click="handleDestroy(item)"
                        color="danger"
                        small
                        title="Excluir"
                    >
                        <rkm-icon icon="trash" />
                    </rkm-button>
                </template>
            </rkm-table>
        </rkm-area>
    </rkm-form>
</template>

<script>

//Mixins
import {repository, error, object} from '@/mixins'

//Vuex
import {mapActions} from 'vuex'

export default {
    computed: {
        fields() {

            return {
                tables: {
                    assinatura: [
                        { key: 'arquivo', label: 'Arquivo', sortable: true },
                        { key: 'actions', label: 'Ações', class: 'col-min' },
                    ],
                }
            }
        },
    },
    created() {

        this.repositories = {
            usuario: this.getConectaSusRepository('cadastro.sujeitoAtencao.usuario'),
        }

        this.load()
    },
    data: () => ({
        items: [],
        model: {
           assinatura: null,
        },
        assinatura: true,
        fileSize: true,
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {

            this.setLoading()

            this.repositories.usuario.loadAssinatura(this.item.id)
                .then(({data}) => {

                    this.model = this.clone(data.model)

                    this.items = data.model.assinatura

                    if (this.model.assinatura.length == 0) {

                        this.assinatura = false
                        this.$emit('handleShowSave', true)
                    } else {

                        this.$emit('handleShowSave', false)
                    }
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        save() {

            this.$refs.RkmForm.validate()
                .then(valid => {

                    if (!valid) return

                    this.setLoading()

                    this.repositories.usuario.assinatura(this.prepareData())
                        .then(response => {

                            this.showSaveNotification()

                            this.assinatura = true
                            this.$emit('handleShowSave', false)

                            this.items = [response.data]

                        })
                        .catch(this.handleError)
                        .finally(() => this.unsetLoading())
                })
        },
        handleAssinatura() {

            if(!this.model.assinatura || this.model.assinatura && this.model.assinatura.length == 0){

                this.showValidationNotification("É necessário incluir um arquivo.")

                return
            }

            let file = new Image()
            file.src = window.URL.createObjectURL(this.model.assinatura)

            file.onload = () => {

                if(file.width !== 250 || file.height !== 150) {

                    this.showValidationNotification(`O tamanho da imagem deve ser exatamente de 250px de largura
                        e 150px de altura.`)
                } else {

                    this.save()
                }
            }
        },
        prepareData() {

            let arquivo = this.model.assinatura
            let nomeArquivo = this.item.id + new Date().getTime() + '_' + this.item.nome.split(" ").join("_")
            let formData = new FormData()

            formData.append('id', this.item.id)
            formData.append('assinatura[]', new File([arquivo], `${nomeArquivo}.${arquivo.name.split('.').pop()}`))
            formData.append('arquivo', `${nomeArquivo}.${arquivo.name.split('.').pop()}`)

            return formData
        },
        handleDownload(item) {

            this.repositories.usuario.downloadAssinatura(item.id)
                .then(response => {

                    const file = response.headers['content-disposition'].split('filename=')[1]
                    const blob = new Blob([response.data], { type: 'application/png' })
                    const link = document.createElement('a')

                    link.href = window.URL.createObjectURL(blob)
                    link.download = file

                    link.click()
                })
                .catch(this.handleError)
        },
        handleDestroy(item) {

            const destroy = () => this.repositories.usuario.destroyAssinatura(item.id)
                .then(() => {

                    this.assinatura = false
                    this.model.assinatura = null
                    this.$emit('handleShowSave', true)
                })

            this.showDeleteConfirmation('Deseja realmente excluir a assinatura?', destroy, this.handleError)
        },
    },
    mixins: [repository, error, object],
    props: {
        item: { type: Object, required: true },
    },
}
</script>